<template>
  <div class="trochaldisk" v-loading="loading">
    <div class="trochaldisk-first">
      <div class="trochaldisk-first-top">
        <div class="trochaldisk-first-top-left">大转盘活动设置</div>
        <div class="trochaldisk-first-top-right" @click="refresh">刷新</div>
      </div>

      <div class="trochaldisk-first-table">
        <el-table
          :data="firstTable"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column prop="integral" label="转盘消耗积分" width="112">
          </el-table-column>

          <el-table-column label="规则说明">
            <template slot-scope="scope">
              <div class="table-rule" v-html="scope.row.detail"></div>
            </template>
          </el-table-column>
          <el-table-column label="是否启用" width="110">
            <template slot-scope="scope">
              <div class="table-status">
                <el-switch
                  :value="coronaStatus"
                  active-color="#13ce66"
                  inactive-color="#D9D9D9"
                  @change="switchChange(scope.row.status)"
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <div class="table-operate" @click="redactBtn(scope.row)">
                编辑
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="trochaldisk-second">
      <div class="trochaldisk-second-top">大转盘奖品设置</div>
      <div class="trochaldisk-second-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <el-table-column
            prop="id"
            label="权重顺序（权重越前，概率越低）"
            width="248"
          >
          </el-table-column>
          <el-table-column prop="lunck_name" label="奖品名称">
          </el-table-column>

          <el-table-column label="奖品图片" width="234">
            <template slot-scope="scope">
              <img class="prize-img" :src="scope.row.lunck_image" />
            </template>
          </el-table-column>
          <el-table-column prop="consume" label="奖品类型" width="112">
            <template slot-scope="scope">
              {{
                scope.row.lunck_type == 0
                  ? '谢谢惠顾'
                  : scope.row.lunck_type == 1
                  ? '积分'
                  : scope.row.lunck_type == 2
                  ? '商品'
                  : ''
              }}
            </template>
          </el-table-column>

          <el-table-column label="成本(元)" width="122">
            <template slot-scope="scope">
              ¥ &nbsp;{{ scope.row.lunck_cost }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="110">
            <template slot-scope="scope">
              <div class="table-operate" @click="compileBtn(scope.row)">
                编辑
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--switch状态开启关闭-->
    <div class="trochaldisk-switch">
      <el-dialog
        :visible.sync="switchDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="switchClose"
      >
        <span slot="footer" class="dialog-footer">
          <div class="switch-div">
            <img
              class="switch-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="switch-div-title">
              {{
                coronaStatus == false
                  ? '是否确定启用该大转盘活动 ?'
                  : '是否确定禁用该大转盘活动 ?'
              }}
            </div>
            <div class="switch-div-text">
              {{
                coronaStatus == false
                  ? '一旦启用成功则用户可参与此活动。'
                  : '一旦禁用成功则用户不可参与此活动。'
              }}
            </div>
            <div class="switch-div-button">
              <div class="switch-div-button-left" @click="swicthBtn">确定</div>
              <div class="switch-div-button-right" @click="switchClose">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--左侧编辑-->
    <div class="trochaldisk-Edit1">
      <el-dialog
        :visible.sync="Edit1DialogVisible"
        width="444px"
        style="margin-top: 10vh"
        @close="Edit1reset(0)"
      >
        <span slot="footer" class="dialog-footer">
          <div class="Edit1-div">
            <div class="Edit1-div-top">
              <div class="Edit1-div-top-title">编辑</div>
              <img
                class="Edit1-div-top-img"
                @click="Edit1Close(0)"
                src="../../assets/activities/activities-close.png"
              />
            </div>

            <div class="Edit1-div-center">
              <div class="Edit1-div-center-header">
                <div class="header-title">标题</div>
                <div class="header-input">
                  <el-input
                    placeholder="请输入活动标题"
                    v-model="Edit1title"
                    clearable
                  >
                  </el-input>
                </div>
              </div>

              <div class="Edit1-div-center-expend">
                <div class="expend-title">转盘消耗积分</div>
                <div class="expend-input">
                  <el-input
                    placeholder="请输入转盘消耗积分"
                    v-model="Edit1expend"
                    clearable
                  >
                  </el-input>
                </div>
              </div>

              <div class="Edit1-div-center-textarea">
                <div class="expend-title">规则说明</div>
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="Edit1textarea"
                  maxlength=""
                  show-word-limit
                >
                </el-input>
              </div>
            </div>

            <div class="Edit1-div-button">
              <!-- <div class="button-reset" @click="Edit1reset(0)">重置</div> -->
              <div class="button-confirm" @click="Edit1confirm(0)">确定</div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--右侧编辑-->
    <div class="trochaldisk-Edit2">
      <el-dialog
        :visible.sync="Edit2DialogVisible"
        width="444px"
        style="margin-top: 10vh"
        @close="Edit1reset(1)"
      >
        <span slot="footer" class="dialog-footer">
          <div class="Edit2-div">
            <div class="Edit1-div-top">
              <div class="Edit1-div-top-title">编辑</div>
              <img
                class="Edit1-div-top-img"
                @click="Edit1Close(1)"
                src="../../assets/activities/activities-close.png"
              />
            </div>

            <div class="Edit1-div-center">
              <div class="Edit1-div-center-weight">
                <div class="weight-title">权重顺序</div>
                <div class="weight-num">{{ Edit2weight }}</div>
              </div>

              <div class="Edit1-div-center-header">
                <div class="header-title">奖品名称</div>
                <div class="header-input">
                  <el-input
                    placeholder="请输入奖品名称"
                    v-model="Edit2prizeName"
                    clearable
                  >
                  </el-input>
                </div>
              </div>

              <div class="Edit2-div-center-module">
                <div class="module-left">
                  <div class="module-left-title">奖品图片</div>
                  <!-- <img class="module-left-img" :src="Edit2prizeImages" /> -->
                  <el-upload
                    class="module-left-img"
                    action="https://laravel-api-manager.xmw1688.com/common/upload"
                    list-type="picture-card"
                    :on-success="handleSuccess"
                    :limit="1"
                    :show-file-list="false"
                    ref="upload"
                  >
                    <img
                      v-if="Edit2prizeImages != ''"
                      class="avatar"
                      :src="Edit2prizeImages"
                      alt=""
                    />
                    <img
                      v-else
                      src="../../assets/common/common-uploadings.png"
                      class="avatar"
                    />
                  </el-upload>
                </div>
                <div class="module-right">
                  <div class="module-right-title">奖品类型</div>
                  <div class="module-right-select">
                    <el-select v-model="prizeType" placeholder="请选择">
                      <el-option
                        v-for="item in prizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div class="module-right-title">奖品成本</div>
                  <div class="module-right-input">
                    <el-input
                      placeholder="请输入奖品成本"
                      v-model="prizeCost"
                      class="input-with-select"
                    >
                      <div class="input-append" slot="append">元</div>
                    </el-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="Edit2-div-button">
              <!-- <div class="button-reset" @click="Edit1reset(1)">重置</div> -->
              <div class="button-confirm" @click="Edit1confirm(1)">确定</div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from '../../utils/bus'
import {
  getluck,
  postluckCompile,
  putluckDisable,
  postluckCompileAward,
} from '../../api/activities'

export default {
  comments() {},
  data() {
    return {
      // 是否启动大轮盘开关  false 关闭状态 true 开启状态
      coronaStatus: false,
      // 大轮盘活动设置 第一区域表格
      firstTable: [],

      // 第二区域 展开table表格数组
      tableData: [],
      // 左侧编辑点击是否开启弹出框
      Edit1DialogVisible: false,
      // 左侧编辑弹出框内标题
      Edit1title: '',
      // 左侧编辑弹出框消耗积分
      Edit1expend: '',
      // 左侧编辑弹出框 输入规则说明
      Edit1textarea: '',
      // 右侧编辑弹出框 是否开启
      Edit2DialogVisible: false,
      // 右侧编辑弹出框 权重id
      Edit2weight: '',
      // 右侧编辑弹出框 奖品名称
      Edit2prizeName: '',
      // 右侧编辑弹出框 奖品图片
      Edit2prizeImages: '',
      // 右侧编辑弹出框 奖品类型
      prizeList: [
        {
          value: '0',
          label: '谢谢惠顾',
        },
        {
          value: '1',
          label: '积分',
        },
        {
          value: '2',
          label: '商品',
        },
      ],
      prizeType: '',
      // 右侧编辑弹出框 奖品成本
      prizeCost: '',
      /* 左侧状态栏变化   */
      switchDialogVisible: false,
      // 监听用户刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      activeiesFunShow: false,
    }
  },
  created() {
    // 大轮盘设置请求数据
    this.loading = true
    this.getluckSet()

    setTimeout(() => {
        this.activeiesFunShow = this.$store.state.pageFunctionShow
    }, 1000);
  },
  methods: {
    // 获取大轮盘设置接口数据
    getluckSet() {
      let params = {}
      getluck(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('大轮盘设置', res)
          let Obj = res.resultData
          this.coronaStatus = Obj.status == 0 ? false : true
          // 获取第一区域表格数据
          this.firstTable = []
          this.firstTable.push(Obj)
          // 获取第二区域表格数据
          this.tableData = Obj.luckList
          this.loading = false
        }
      })
    },

    // 用户点击界面刷新
    refresh() {
      this.loading = true

      this.$nextTick(() => {
        this.getluckSet()
      })
    },

    // 监听switch关闭
    switchChange(e) {
      if (this.activeiesFunShow == false) {
        return
      }
      this.switchDialogVisible = true
    },
    // 监听switch的状态切换 确认
    swicthBtn() {
      let params = {}
      // 切换是否开启或者禁用
      putluckDisable(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: this.coronaStatus == false ? '启动成功' : '禁用成功',
            type: 'success',
          })

          this.coronaStatus = !this.coronaStatus
          this.switchDialogVisible = false
        }
      })
    },
    // 监听switch的状态切换 取消
    switchClose() {
      this.switchDialogVisible = false
    },

    // 左侧点击刷新旁边的编辑
    redactBtn(item) {
      if (this.activeiesFunShow == false) {
        return
      }

      console.log('点击编辑', item)
      this.Edit1title = item.title
      this.Edit1expend = item.integral
      this.Edit1textarea = item.detail
      this.Edit1DialogVisible = true
    },
    // 左侧弹窗 点击关闭
    Edit1Close(index) {
      if (index == 0) {
        this.Edit1title = ''
        this.Edit1expend = ''
        this.Edit1textarea = ''
        this.Edit1DialogVisible = false
      } else {
        this.Edit2DialogVisible = false
      }
    },
    // 左侧弹出 重置
    Edit1reset(index) {
      if (index == 0) {
        this.Edit1DialogVisible = false
        this.Edit1title = ''
        this.Edit1expend = ''
        this.Edit1textarea = ''
      } else {
        this.Edit2DialogVisible = false
        this.Edit2prizeName = ''
        this.prizeType = ''
        this.prizeCost = ''
      }
    },
    // 右侧点击商品对应的编辑 用户点击编辑获取用户的id
    compileBtn(item) {
      if (this.activeiesFunShow == false) {
        return
      }

      this.Edit2weight = item.id
      this.Edit2prizeName = item.lunck_name
      this.Edit2prizeImages = item.lunck_image
      this.prizeType =
        item.lunck_type == 0
          ? '谢谢惠顾'
          : item.lunck_type == 1
          ? '积分'
          : item.lunck_type == 2
          ? '商品'
          : ''
      this.prizeCost = item.lunck_cost
      this.Edit2DialogVisible = true
    },
    // 上传成功
    handleSuccess(file, fileList) {
        this.$refs.upload.clearFiles()

      this.Edit2prizeImages = file.resultData
    },
    // 左侧弹出 确定
    Edit1confirm(index) {
      console.log('点击确定')
      if (index == 0) {
        // 第一区域编辑修改对应的值
        let params = {
          title: this.Edit1title, // 标题
          integral: this.Edit1expend, // 消耗积分
          detail: this.Edit1textarea, // 简绍
        }

        postluckCompile(params).then((res) => {
          if (res.resultStatus == true) {
            this.$message({
              message: '修改成功',
              type: 'success',
            })
            this.$nextTick(() => {
              this.loading = true
              this.getluckSet()
            })
          }
        })

        this.Edit1DialogVisible = false
      } else {
        // 大轮盘编辑奖励获取
        let params = {
          id: this.Edit2weight,
          lunck_name: this.Edit2prizeName,
          lunck_image: this.Edit2prizeImages,
          lunck_type:
            this.prizeType == '谢谢惠顾'
              ? '0'
              : this.prizeType == '积分'
              ? '1'
              : this.prizeType == '商品'
              ? '2'
              : '',
          lunck_cost: this.prizeCost,
          integral: '',
        }

        postluckCompileAward(params).then((res) => {
          console.log('获取对应的编辑成功', res)
          if (res.resultStatus == true) {
            this.$message({
              message: '修改成功',
              type: 'success',
            })

            this.Edit2DialogVisible = false

            this.$nextTick(() => {
              this.loading = true
              this.getluckSet()
            })
          }
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.trochaldisk {
  width: 100%;

  .trochaldisk-first {
    height: 210px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    box-sizing: border-box;
    .trochaldisk-first-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 68px;

      .trochaldisk-first-top-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .trochaldisk-first-top-right {
        width: 70px;
        height: 36px;
        border-radius: 10px;
        border: 1px solid rgba(34, 34, 34, 0.4);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }
    }

    .trochaldisk-first-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      .table-rule {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .table-status {
        width: 42px;
        /deep/ .el-switch__core {
          width: 42px !important;
        }
      }

      .table-operate {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
      }
    }
  }
  .trochaldisk-second {
    margin-top: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px 24px;
    box-sizing: border-box;
    .trochaldisk-second-top {
      height: 68px;
      box-sizing: border-box;
      line-height: 68px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
    }

    .trochaldisk-second-table {
      /deep/ .el-table .el-table__cell {
        padding: 13px 0;
        vertical-align: top;
      }

      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      .prize-img {
        width: 120px;
        height: 70px;
      }

      .table-operate {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
      }
    }
  }

  .trochaldisk-Edit1,
  .trochaldisk-Edit2 {
    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    /deep/ .el-dialog {
      height: 438px;
      border-radius: 10px !important;
    }

    .Edit1-div,
    .Edit2-div {
      width: 100%;

      .Edit1-div-top {
        display: flex;
        height: 56px;
        align-items: center;
        padding: 0 24px;
        box-sizing: border-box;
        justify-content: space-between;
        border-bottom: 1px solid #d9d9d9;
        .Edit1-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
        }

        .Edit1-div-top-img {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }

      .Edit1-div-center {
        padding: 14px 24px;
        box-sizing: border-box;
        .Edit1-div-center-header,
        .Edit1-div-center-expend {
          .header-title,
          .expend-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .header-input,
          .expend-input {
            margin-top: 4px;
            width: 100%;
            height: 100%;

            /deep/ .el-input {
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }
          }
        }

        .Edit1-div-center-expend {
          margin-top: 14px;
        }

        .Edit1-div-center-textarea {
          margin-top: 14px;
          height: 152px;
          background: #ffffff;
          border-radius: 5px;

          .expend-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          /deep/ .el-textarea {
            height: 100%;
            cursor: pointer;
          }

          /deep/ .el-textarea__inner {
            height: 100%;
            padding: 10px 10px 20px;
          }

          /deep/ .el-textarea .el-textarea__inner {
            // 然后找到对应的类名，在这里将拉伸去掉即可
            resize: none;
          }
        }

        /* 右侧编辑权重 */
        .Edit1-div-center-weight {
          margin-bottom: 10px;
          .weight-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .weight-num {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-top: 3px;
          }
        }

        .Edit2-div-center-module {
          display: flex;
          margin-top: 14px;
          .module-left {
            .module-left-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .module-left-img {
              width: 100px;
              height: 100px;
              position: relative;
              margin-top: 8px;

              /deep/ .el-upload--picture-card {
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              /deep/ .el-upload--picture-card:hover {
                border-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-upload-list--picture-card .el-upload-list__item {
                width: 100px;
                height: 100px;
                margin: 0;
              }
              .avatar {
                width: 100px;
                height: 100px;
              }
            }
          }

          .module-right {
            margin-left: 58px;
            width: 100%;
            .module-right-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .module-right-select {
              margin-top: 4px;
              margin-bottom: 14px;
              /deep/ .el-select {
                width: 100%;
              }

              /deep/ .el-input--suffix .el-input__inner {
                height: 32px;
              }

              /deep/ .el-select .el-input.is-focus .el-input__inner {
                border-color: rgba(217, 217, 217, 1);
              }
            }

            .module-right-input {
              width: 100%;
              margin-top: 4px;
              /deep/ .el-input {
                height: 32px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-input-group__append {
                background-color: #ffffff;
                height: 32px;
                padding: 0;
              }
              .input-append {
                width: 38px;
                height: 30px;
                background: #ffffff;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
              }
            }
          }
        }
      }

      .Edit2-div-button,
      .Edit1-div-button {
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 24px;
        box-sizing: border-box;
        border-top: 1px solid #d9d9d9;
        margin-top: 15px;

        .button-reset,
        .button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }

  .trochaldisk-Edit2 {
    /deep/ .el-dialog {
      height: 395px;
      border-radius: 10px !important;
    }

    .Edit2-div-button {
      margin-top: 10px;
    }
  }

  .trochaldisk-switch {
    /deep/ .el-dialog {
      height: 231px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .switch-div {
      width: 100%;
      text-align: center;
      .switch-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .switch-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 8px;
      }

      .switch-div-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 2px;
      }

      .switch-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .switch-div-button-left,
        .switch-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .switch-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
